import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Edit } from 'jbc-front/components/icons';
import { Headding, Item, Panel } from '@/components/PrimaryPanel';
import { Grid } from '@/components/ui/Grid';
import { Dd, Dl, Dt } from '@/components/ui/DefinitionList';
import { displayFormat } from '@/components/utils/formatter';
import { ViewProps } from './ViewProps';

export const Office: FC<ViewProps> = ({ report, editLink }) => {
  return (
    <Panel>
      <Link to={`${editLink}#office`}>
        <Headding icon={<Edit icon={16} />}>集計に含める事業所</Headding>
      </Link>
      <Item>
        <Grid>
          <Dl>
            <Dt>集計に含める事業所</Dt>
            <Dd>
              {report.aggregationOffices && report.aggregationOffices.length > 0
                ? report.aggregationOffices.map((aggregationOffice, index) => (
                    <p key={index}>{displayFormat(aggregationOffice.name)}</p>
                  ))
                : displayFormat()}
            </Dd>
          </Dl>
        </Grid>
      </Item>
    </Panel>
  );
};
